import { getNestedValue } from "../../../../../utils/function";

const PhishBoxSubmit = (props) => {
  const submitType = props?.row?.original?.submitType || props?.row?.original?.submit_type;
  let displayedDate = "-";

  const accessor = props.column.id;
  const time = getNestedValue(props.row.original, accessor, "-");
  const timeStr = time.$date || time;

  try {
    const splittedDate = timeStr.split("T");
    const ymd = splittedDate[0] || "-";
    const hms = splittedDate[1].split(".")[0] || "-";
    displayedDate = `${ymd} (${hms})`;
  } catch (e) {}

  return (
    <p style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
      <span style={{ whiteSpace: "nowrap" }}>{displayedDate}</span>
      <span style={{ color: "rgb(155, 155, 155)" }}>{submitType}</span>
    </p>
  );
};

export default PhishBoxSubmit;
